export class UserDateAudit {
    createdAt: Date;
    createdBy: number;
    deletedAt: Date;
    deletedBy: number;
    updatedAt: Date;
    updatedBy: number;
    version: number;
}
